import Big from "big.js";

export function max(left: Big, right: Big): Big {
  if (left.gte(right)) {
    return left;
  }
  return right;
}